const ExternalCompanyHoldings = {
  SubTitle: "ExternalCompanyHoldings.SubTitle",
  K10Description: "ExternalCompanyHoldings.K10Description",
  ListOfKnownCompanies: "ExternalCompanyHoldings.ListOfKnownCompanies",
  AddExternalHoldings: "ExternalCompanyHoldings.AddExternalHoldings",
  AddExternalHoldingsDescription: "ExternalCompanyHoldings.AddExternalHoldingsDescription",
  SpousePersonalNumberTitle: "ExternalCompanyHoldings.SpousePersonalNumberTitle",
  SpousePersonalNumberDescription: "ExternalCompanyHoldings.SpousePersonalNumberDescription",
  SpousePersonalNumberPlaceholder: "ExternalCompanyHoldings.SpousePersonalNumberPlaceholder",
  ExternalCompanyHoldings: "ExternalCompanyHoldings.ExternalCompanyHoldings",
  CompanyName: "ExternalCompanyHoldings.CompanyName",
  Ownership: "ExternalCompanyHoldings.Ownership",
  SpousePersonalNumberFormat: "ExternalCompanyHoldings.SpousePersonalNumberFormat",
  SpousePersonalNumberNotInOwners: "ExternalCompanyHoldings.SpousePersonalNumberNotInOwners",
  SpouseCoordinationNumberWarning: "ExternalCompanyHoldings.SpouseCoordinationNumberWarning",
  }
export default ExternalCompanyHoldings;